import React from 'react'
import MuiTableRow from '@mui/material/TableRow'
import url from 'libraries/front-end-core/core/url'
import { MW_DEAL_DETAILS } from 'constants/controllers'
import { LayoutHeader } from 'components/dealwatch/Layout'
import TableCell from 'components/dealwatch/TableCell'
import Table from './Table'
import { useSelector } from 'react-redux'
import selectAolName from 'redux/selectors/selectAolName'

const DealMilestones = ({ timeline, dealId }) => {
  const aol = useSelector(selectAolName)

  return (
    <>
      <LayoutHeader title='Milestones' />
      <Table columnCount={3} columnTitles={['Date', 'Event', 'Relevant links and files']}>
        {timeline.map((event, index) => (
          <MuiTableRow key={index}>
            <TableCell>
              {event.date.format('DD/MM/YYYY')}
            </TableCell>
            <TableCell>
              {event.label}
            </TableCell>
            <TableCell>
              <a href={url(MW_DEAL_DETAILS, { aol, dealId }, { docId: event.document.id })} className='pointer underline'>
                {event.document.filename}
              </a>
            </TableCell>
          </MuiTableRow>
        ))}
      </Table>
    </>
  )
}

export default DealMilestones
